(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
class LoadMoreGrid extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.button = this.querySelector('.tt-loadmore__btn');
    this.textEl = this.querySelector('.tt-loadmore__text');
    this.errorEl = this.querySelector('.tt-loadmore__error');
    if (!this.button) return;
    this.button.addEventListener('click', this.loadMore.bind(this));
  }

  get nextUrl() {
    return this.getAttribute('data-next-url');
  }

  setLoading(isLoading) {
    this.loading = isLoading;
    this.button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    this.button.disabled = isLoading;
    if (!this.textEl) return;
    const label = this.button.getAttribute('data-label');
    const loadingLabel = this.button.getAttribute('data-loading-label');
    this.textEl.textContent = isLoading && loadingLabel ? loadingLabel : label;
  }

  showError() {
    if (!this.errorEl) return;
    this.errorEl.textContent = this.getAttribute('data-error') || '';
    this.errorEl.hidden = false;
  }

  async loadMore() {
    const url = this.nextUrl;
    if (!url || this.loading) return;
    if (this.errorEl) this.errorEl.hidden = true;
    this.setLoading(true);

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(response.status);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const currentGrid = document.getElementById('product-grid');
      const newGrid = doc.getElementById('product-grid');
      let firstNew = null;

      if (currentGrid && newGrid) {
        const fragment = document.createDocumentFragment();
        newGrid.querySelectorAll('li.grid__item').forEach((item) => {
          const node = document.importNode(item, true);
          node.classList.remove('scroll-trigger', 'animate--slide-in');
          node.removeAttribute('data-cascade');
          node.style.removeProperty('--animation-order');
          node.classList.add('tt-loadmore-added');
          if (!firstNew) firstNew = node;
          fragment.appendChild(node);
        });
        currentGrid.appendChild(fragment);
      }

      const nextLoader = doc.querySelector('load-more-grid');
      const nextUrl = nextLoader && nextLoader.getAttribute('data-next-url');

      if (nextUrl) {
        this.setAttribute('data-next-url', nextUrl);
        this.setLoading(false);
        this.button.focus({ preventScroll: true });
      } else {
        // Last batch loaded: keep keyboard focus in the grid, then remove the button.
        if (firstNew) {
          firstNew.setAttribute('tabindex', '-1');
          firstNew.focus({ preventScroll: true });
        }
        this.remove();
      }
    } catch (error) {
      this.setLoading(false);
      this.showError();
    }
  }
}

if (!customElements.get('load-more-grid')) {
  customElements.define('load-more-grid', LoadMoreGrid);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testatoro-customer-chats"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('testatoro-customer-chats')) {
    customElements.define(
      'testatoro-customer-chats',
      class TestatoroCustomerChats extends HTMLElement {
        connectedCallback() {
          // Moving a section in the theme editor reconnects the same element: wire it up once.
          if (this.wired) return;
          this.wired = true;
          this.step = parseInt(this.dataset.step, 10) || 8;
          this.moreWrap = this.querySelector('.ttrt__more');
          this.dialog = this.querySelector('.ttrt__lightbox');
          this.full = this.dialog ? this.dialog.querySelector('.ttrt__lb-img') : null;

          this.addEventListener('click', (event) => {
            if (event.target.closest('[data-ttrt-more]')) return this.showMore();
            const shot = event.target.closest('.ttrt__chat-btn');
            if (shot) this.open(shot);
          });

          if (this.dialog) {
            // A tap on the dark area around the screenshot, or on the close button, closes it.
            this.dialog.addEventListener('click', (event) => {
              if (event.target === this.dialog || event.target.closest('.ttrt__lb-close')) this.dialog.close();
            });
            // Drop the picture on close, so the next one never opens showing the previous chat
            // while its own file is still downloading on a slow connection.
            this.dialog.addEventListener('close', () => {
              document.body.classList.remove('overflow-hidden');
              this.full.removeAttribute('src');
            });
          }
        }

        showMore() {
          const hidden = Array.from(this.querySelectorAll('.ttrt__chat[hidden]'));
          const next = hidden.slice(0, this.step);
          next.forEach((item) => (item.hidden = false));
          // Keyboard users land on the first new screenshot rather than on a vanished button.
          const first = next[0] && next[0].querySelector('.ttrt__chat-btn');
          if (hidden.length <= this.step && this.moreWrap) this.moreWrap.hidden = true;
          if (first) first.focus();
        }

        open(shot) {
          if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
          const thumb = shot.querySelector('img');
          this.full.src = shot.getAttribute('data-ttrt-full');
          this.full.alt = thumb ? thumb.alt : '';
          this.dialog.showModal();
          this.dialog.scrollTop = 0;
          document.body.classList.add('overflow-hidden');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testatoro-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.theroInit) return;
    root.dataset.theroInit = '1';
    var track = root.querySelector('.tthero__track');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.tthero__slide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.tthero__dot'));
    if (!track || slides.length <= 1) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var n = slides.length;
    var current = 0;
    var timer = null, resumeTimer = null;
    var speed = parseInt(root.dataset.speed, 10) || 5000;
    var autoplay = root.dataset.autoplay === 'true' && !reduce;

    function goTo(i, instant) {
      i = (i % n + n) % n;
      var delta = slides[i].getBoundingClientRect().left - track.getBoundingClientRect().left;
      if (delta) track.scrollBy({ left: delta, behavior: (instant || reduce) ? 'auto' : 'smooth' });
    }
    function setCurrent(i) {
      if (i === current && dots[i] && dots[i].classList.contains('is-active')) return;
      current = i;
      dots.forEach(function (d, di) {
        var on = di === i;
        d.classList.toggle('is-active', on);
        if (on) { d.setAttribute('aria-current', 'true'); } else { d.removeAttribute('aria-current'); }
      });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio >= 0.6) {
            var idx = slides.indexOf(e.target);
            if (idx !== -1) setCurrent(idx);
          }
        });
      }, { root: track, threshold: [0.6] });
      slides.forEach(function (s) { io.observe(s); });
    }
    dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });
    var prev = root.querySelector('.tthero__arrow--prev');
    var next = root.querySelector('.tthero__arrow--next');
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    var userPaused = false;
    function pause() { if (timer) { clearTimeout(timer); timer = null; } }
    function play() {
      if (!autoplay || userPaused) return;
      pause();
      timer = setTimeout(function () {
        var nextIdx = (current + 1) % n;
        goTo(nextIdx, nextIdx === 0);
        play();
      }, speed);
    }
    var toggle = root.querySelector('.tthero__toggle');
    if (toggle) {
      toggle.addEventListener('click', function () {
        userPaused = !userPaused;
        toggle.classList.toggle('is-paused', userPaused);
        toggle.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        toggle.setAttribute('aria-label', userPaused ? toggle.dataset.labelPlay : toggle.dataset.labelPause);
        if (userPaused) { pause(); } else { play(); }
      });
    }
    if (autoplay) {
      var onVisibility = function () { if (document.hidden) { pause(); } else { play(); } };
      root.addEventListener('pointerenter', pause);
      root.addEventListener('pointerleave', play);
      root.addEventListener('pointerdown', pause);
      root.addEventListener('pointerup', function () { clearTimeout(resumeTimer); resumeTimer = setTimeout(play, 2500); });
      root.addEventListener('focusin', pause);
      root.addEventListener('focusout', play);
      document.addEventListener('visibilitychange', onVisibility);
      var section = root.closest('.shopify-section');
      if (section) {
        section.addEventListener('shopify:section:unload', function () {
          document.removeEventListener('visibilitychange', onVisibility);
          pause();
          if (resumeTimer) { clearTimeout(resumeTimer); }
        }, { once: true });
      }
      play();
    }
    root.addEventListener('shopify:block:select', function (e) {
      pause();
      var slide = e.target.closest ? e.target.closest('.tthero__slide') : null;
      var idx = slides.indexOf(slide || e.target);
      if (idx !== -1) goTo(idx);
    });
    root.addEventListener('shopify:block:deselect', function () { play(); });
  }
  function initAll() { document.querySelectorAll('.tthero').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll); } else { initAll(); }
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector ? e.target.querySelector('.tthero') : null;
    if (root) init(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testatoro-logo-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('testatoro-logo-marquee')) {
    customElements.define(
      'testatoro-logo-marquee',
      class TestatoroLogoMarquee extends HTMLElement {
        connectedCallback() {
          const marquee = this.querySelector('.ttlm__marquee');
          if (!marquee || !('IntersectionObserver' in window)) return;
          this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => marquee.classList.toggle('is-paused', !entry.isIntersecting));
          });
          this.observer.observe(marquee);
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testatoro-pg-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('testatoro-pg-tabs')) {
    customElements.define(
      'testatoro-pg-tabs',
      class TestatoroPgTabs extends HTMLElement {
        connectedCallback() {
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
          } else {
            this.init();
          }
        }

        disconnectedCallback() {
          if (this.sizeObserver) this.sizeObserver.disconnect();
          if (this.onScroll) {
            window.removeEventListener('scroll', this.onScroll);
            window.removeEventListener('resize', this.onScroll);
          }
          if (this.onSectionChange) {
            ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach((type) =>
              document.removeEventListener(type, this.onSectionChange)
            );
          }
          document.documentElement.style.removeProperty('--ttpg-top');
          document.documentElement.style.removeProperty('--ttpg-nav');
        }

        init() {
          if (!this.isConnected) return;
          this.nav = this.querySelector('.ttpg__nav');
          this.tabs = Array.from(this.querySelectorAll('[data-ttpg-tab]'));
          this.findPanels();
          this.syncTabs();
          this.measure();
          this.spyOnPanels();

          // In the theme editor, panel sections can be added, removed or moved under us.
          this.onSectionChange = () => requestAnimationFrame(() => {
            this.findPanels();
            this.syncTabs();
            this.active = undefined;
            this.updateActiveTab();
          });
          ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach((type) =>
            document.addEventListener(type, this.onSectionChange)
          );
        }

        // Panels live in other sections; looked up once, and again only when sections change.
        findPanels() {
          this.panels = Array.from(document.querySelectorAll('[data-ttpg-panel]'));
        }

        // A tab whose panel section was removed or hidden would be a dead link.
        syncTabs() {
          this.tabs.forEach((tab) => {
            tab.hidden = !document.getElementById(tab.getAttribute('data-ttpg-tab'));
          });
        }

        // --ttpg-top: the always-sticky header, whose height changes as its logo shrinks on
        //             scroll ("reduce logo size"), so it is watched live;
        // --ttpg-nav: the tabs themselves, which grow if a label wraps.
        measure() {
          if (!('ResizeObserver' in window)) return;
          const root = document.documentElement;
          const stickyHeader = document.querySelector('sticky-header');
          const type = stickyHeader && stickyHeader.getAttribute('data-sticky-type');
          const header =
            type === 'always' || type === 'reduce-logo-size' ? document.querySelector('.section-header') : null;

          this.sizeObserver = new ResizeObserver(() => {
            if (header) root.style.setProperty('--ttpg-top', `${header.offsetHeight}px`);
            if (this.nav) root.style.setProperty('--ttpg-nav', `${this.nav.offsetHeight}px`);
          });
          if (header) this.sizeObserver.observe(header);
          if (this.nav) this.sizeObserver.observe(this.nav);
        }

        // The active tab belongs to the last panel whose top has passed a line a quarter of the
        // way down the space under the tabs. Measured on scroll rather than with an
        // IntersectionObserver band: a thin band misses short panels on tall screens, and
        // rootMargin is ignored inside the theme editor's cross-origin preview frame.
        spyOnPanels() {
          if (!this.tabs.length) return;
          this.onScroll = () => {
            if (this.ticking) return;
            this.ticking = true;
            requestAnimationFrame(() => {
              this.ticking = false;
              this.updateActiveTab();
            });
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll, { passive: true });
          this.updateActiveTab();
        }

        updateActiveTab() {
          const navBottom = this.nav ? Math.max(this.nav.getBoundingClientRect().bottom, 0) : 0;
          const line = navBottom + (window.innerHeight - navBottom) * 0.25;
          let active = '';
          this.panels.forEach((panel) => {
            if (panel.getBoundingClientRect().top <= line) active = panel.getAttribute('data-ttpg-panel');
          });
          if (active === this.active) return;
          this.active = active;
          this.tabs.forEach((tab) => {
            const isActive = tab.getAttribute('data-ttpg-tab') === active;
            tab.classList.toggle('is-active', isActive);
            if (isActive) {
              tab.setAttribute('aria-current', 'location');
            } else {
              tab.removeAttribute('aria-current');
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testatoro-rt-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('testatoro-rt-hero')) {
    customElements.define(
      'testatoro-rt-hero',
      class TestatoroRtHero extends HTMLElement {
        connectedCallback() {
          // The target sections come after this one, so wait until the page is parsed.
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.sync(), { once: true });
          } else {
            this.sync();
          }
          // In the theme editor, sections can be added, removed or moved under us.
          this.onSectionChange = () => requestAnimationFrame(() => this.sync());
          ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach((type) =>
            document.addEventListener(type, this.onSectionChange)
          );
        }

        disconnectedCallback() {
          ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach((type) =>
            document.removeEventListener(type, this.onSectionChange)
          );
        }

        // A jump link to a missing section hides; the customers line stays, as plain text.
        sync() {
          this.querySelectorAll('[data-ttrt-target]').forEach((link) => {
            const id = link.getAttribute('data-ttrt-target');
            const present = !!document.getElementById(id);
            if (link.classList.contains('ttrt__jump')) {
              link.hidden = !present;
            } else if (present) {
              link.setAttribute('href', `#${id}`);
            } else {
              link.removeAttribute('href');
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testatoro-rt-steps"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('testatoro-rt-video')) {
    customElements.define(
      'testatoro-rt-video',
      class TestatoroRtVideo extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          if (!this.video) return;

          // Moving a section in the theme editor reconnects the same element: the click and
          // media listeners are added once; only the observer is rebuilt on each connect.
          if (!this.wired) {
            this.wired = true;
            this.soundButton = this.querySelector('.ttrt__sound');
            this.userPaused = false;
            this.video.addEventListener('play', () => this.classList.add('is-playing'));
            ['pause', 'ended'].forEach((type) =>
              this.video.addEventListener(type, () => this.classList.remove('is-playing'))
            );
            this.video.addEventListener('click', () => this.toggle());
            const playButton = this.querySelector('.ttrt__play');
            if (playButton) playButton.addEventListener('click', () => this.toggle());
            if (this.soundButton) this.soundButton.addEventListener('click', () => this.toggleSound());
          }

          // Plays (muted) once half of it is on screen. Scrolled away it pauses and its sound
          // goes back off, so coming back never starts it with sound. Never restarts by itself
          // after it has ended, or after the shopper paused it.
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (reduced || !('IntersectionObserver' in window)) return;
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  if (!this.userPaused && !this.video.ended) this.play();
                } else {
                  if (!this.video.paused) this.video.pause();
                  if (!this.video.muted) this.setMuted(true);
                }
              });
            },
            { threshold: 0.5 }
          );
          this.observer.observe(this.video);
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }

        play() {
          const attempt = this.video.play();
          if (attempt && attempt.catch) attempt.catch(() => {});
        }

        toggle() {
          if (this.video.paused) {
            this.userPaused = false;
            this.play();
          } else {
            this.userPaused = true;
            this.video.pause();
          }
        }

        setMuted(muted) {
          this.video.muted = muted;
          this.classList.toggle('is-unmuted', !muted);
          if (this.soundButton) {
            this.soundButton.setAttribute(
              'aria-label',
              this.soundButton.getAttribute(muted ? 'data-label-unmute' : 'data-label-mute')
            );
          }
        }

        toggleSound() {
          const muted = !this.video.muted;
          this.setMuted(muted);
          if (!muted && this.video.paused) {
            this.userPaused = false;
            this.play();
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testatoro-text-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('testatoro-text-marquee')) {
    customElements.define(
      'testatoro-text-marquee',
      class TestatoroTextMarquee extends HTMLElement {
        connectedCallback() {
          const marquee = this.querySelector('.ttxm__marquee');
          if (!marquee || !('IntersectionObserver' in window)) return;
          this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => marquee.classList.toggle('is-paused', !entry.isIntersecting));
          });
          this.observer.observe(marquee);
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testatoro-video-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function loadAndPlay(v) {
      if (v.getAttribute('preload') === 'none') { v.setAttribute('preload', 'auto'); v.load(); }
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    }

    function fire(el, name) {
      var ev;
      try { ev = new CustomEvent(name); }
      catch (e) { ev = document.createEvent('Event'); ev.initEvent(name, false, false); }
      el.dispatchEvent(ev);
    }

    function resetShop(slide) { slide.classList.remove('is-paused'); }

    // Shoppable video slides: the product box is always visible; tapping the media toggles pause/resume.
    function setupShop(slide) {
      var tap = slide.querySelector('[data-ttvc-tap]'); if (!tap) return;
      var v = slide.querySelector('[data-ttvc-video]'); if (!v) return;
      function sync() { tap.setAttribute('aria-label', v.paused ? tap.dataset.labelPlay : tap.dataset.labelPause); }
      tap.addEventListener('click', function () {
        if (v.paused) {
          slide.classList.remove('is-paused');
          delete slide.dataset.ttvcUserPaused;
          fire(slide, 'ttvc:resume'); // desktop: re-enter the sequence at this slide
          loadAndPlay(v);
        } else {
          slide.classList.add('is-paused');
          slide.dataset.ttvcUserPaused = '1';
          v.pause();
        }
      });
      v.addEventListener('play', sync);
      v.addEventListener('pause', sync);
      sync();
    }

    function wireControls(slide) {
      var v = slide.querySelector('[data-ttvc-video]'); if (!v) return;
      var playBtn = slide.querySelector('[data-ttvc-playpause]');
      var muteBtn = slide.querySelector('[data-ttvc-mute]');

      function syncPlay() {
        if (!playBtn) return;
        var playing = !v.paused && !v.ended;
        playBtn.classList.toggle('is-playing', playing);
        playBtn.setAttribute('aria-label', playing ? playBtn.dataset.labelPause : playBtn.dataset.labelPlay);
      }
      function syncMute() {
        if (!muteBtn) return;
        muteBtn.classList.toggle('is-unmuted', !v.muted);
        muteBtn.setAttribute('aria-label', v.muted ? muteBtn.dataset.labelUnmute : muteBtn.dataset.labelMute);
      }

      if (playBtn) playBtn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (v.paused) { delete slide.dataset.ttvcUserPaused; loadAndPlay(v); }
        else { slide.dataset.ttvcUserPaused = '1'; v.pause(); }
      });
      if (muteBtn) muteBtn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        v.muted = !v.muted;
        if (!v.muted && v.paused && !slide.dataset.ttvcUserPaused) loadAndPlay(v);
      });

      v.addEventListener('play', syncPlay);
      v.addEventListener('pause', syncPlay);
      v.addEventListener('ended', syncPlay);
      v.addEventListener('volumechange', syncMute);
      syncPlay(); syncMute();
    }

    // Desktop: hover a card to play it (loops while hovered); with no hover, play videos one
    // at a time in order, each starting when the previous ends. Image slides are skipped.
    function setupDesktop(slides) {
      var vids = slides.map(function (s) { return s.querySelector('[data-ttvc-video]'); });
      var videoIdx = [];
      vids.forEach(function (v, i) { if (v) videoIdx.push(i); });
      if (!videoIdx.length) return;
      var seqPos = 0, hovered = -1, resumeT = null;

      function playAt(idx, doLoop) {
        vids.forEach(function (v, i) {
          if (!v) return;
          if (i === idx) { v.loop = !!doLoop; loadAndPlay(v); } else { v.pause(); }
        });
      }
      function playSeq() {
        if (hovered !== -1) return;
        for (var t = 0; t < videoIdx.length; t++) {
          var idx = videoIdx[seqPos];
          if (!slides[idx].dataset.ttvcUserPaused) { playAt(idx, false); return; }
          seqPos = (seqPos + 1) % videoIdx.length; // skip slides paused by an open product box
        }
      }

      slides.forEach(function (s, i) {
        var v = vids[i];
        if (v) {
          v.addEventListener('ended', function () {
            if (hovered !== -1 || i !== videoIdx[seqPos]) return;
            seqPos = (seqPos + 1) % videoIdx.length;
            playSeq();
          });
        }
        s.addEventListener('ttvc:resume', function () {
          var p = videoIdx.indexOf(i); if (p !== -1) seqPos = p;
          hovered = -1;
          playSeq();
        });
        s.addEventListener('pointerenter', function () {
          if (!vids[i] || s.dataset.ttvcUserPaused) return;
          clearTimeout(resumeT);
          hovered = i;
          playAt(i, true);
        });
        s.addEventListener('pointerleave', function () {
          if (hovered !== i) return;
          hovered = -1;
          var p = videoIdx.indexOf(i); if (p !== -1) seqPos = p;
          clearTimeout(resumeT);
          resumeT = setTimeout(function () { if (hovered === -1) playSeq(); }, 120);
        });
      });

      // The row opens on its first card, so the sequence starts there: seqPos is already 0, and
      // videoIdx[0] is the first slide that actually holds a video (image slides are skipped).
      playSeq();
    }

    // Desktop prev/next. The track hides its scrollbar, so a mouse has no way to move the row
    // and no sign that it can be moved. The buttons appear only when the cards overflow, and
    // each switches off at its end of the row. Touch swipe/snap is untouched.
    function setupNav(root) {
      var track = root.querySelector('.ttvc__track');
      var prev = root.querySelector('[data-ttvc-nav="prev"]');
      var next = root.querySelector('[data-ttvc-nav="next"]');
      if (!track || !prev || !next) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var ticking = false;

      function step() {
        var slide = track.querySelector('.ttvc__slide');
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return slide ? slide.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      }
      function sync() {
        var max = track.scrollWidth - track.clientWidth;
        var pos = Math.abs(track.scrollLeft); // RTL runs scrollLeft 0 → negative
        root.classList.toggle('is-scrollable', max > 4);
        prev.disabled = pos <= 2;
        next.disabled = pos >= max - 2;
      }
      function go(sign) {
        var rtl = getComputedStyle(track).direction === 'rtl';
        track.scrollBy({ left: sign * step() * (rtl ? -1 : 1), behavior: reduce ? 'auto' : 'smooth' });
      }

      prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; sync(); });
      }, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(sync).observe(track);
      else window.addEventListener('resize', sync);
      sync();
    }

    function initCarousel(root) {
      if (!root || root.dataset.ttvcInit) return;
      root.dataset.ttvcInit = '1';
      root.classList.add('ttvc--ready');

      var slides = Array.prototype.slice.call(root.querySelectorAll('.ttvc__slide'));
      slides.forEach(wireControls);
      slides.forEach(setupShop);
      setupNav(root); // before the reduced-motion return — navigation isn't an animation

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) return; // controls still work; no autoplay under reduced motion

      if (window.matchMedia('(min-width: 750px)').matches) { setupDesktop(slides); return; }

      if (!('IntersectionObserver' in window)) return;
      root.classList.add('is-enhanced');
      var ratios = new Map();
      function refresh() {
        var active = null, best = 0.55;
        slides.forEach(function (s) { var r = ratios.get(s) || 0; if (r > best) { best = r; active = s; } });
        slides.forEach(function (s) {
          s.classList.toggle('is-active', s === active);
          var out = (ratios.get(s) || 0) < 0.05;
          if (out) { delete s.dataset.ttvcUserPaused; resetShop(s); }
          var v = s.querySelector('[data-ttvc-video]'); if (!v) return;
          if (s === active) {
            if (!s.dataset.ttvcUserPaused) loadAndPlay(v);
          } else {
            v.pause();
            if (out) v.muted = true;
          }
        });
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { ratios.set(e.target, e.intersectionRatio); });
        refresh();
      }, { threshold: [0, 0.05, 0.25, 0.5, 0.55, 0.75, 1] });
      slides.forEach(function (s) { io.observe(s); });
    }
    function initAll() { document.querySelectorAll('.ttvc').forEach(initCarousel); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('.ttvc') : null;
      if (root) initCarousel(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
